import type { RootState } from "single-spa/store/types";

export const selectWidgetFilters = (state: RootState) => state.customDashboard.dashboardWizard.widget.filters;
export const selectCustomSegmentsGroups = (state: RootState) => state.segmentsModule?.customSegmentsMeta?.SegmentGroups;

export const selectUniqueSegments = (state: RootState) => state.segmentsModule?.dashboardSegmentsMeta?.UniqueSegments;
export const selectAccountSegments = (state: RootState) => state.segmentsModule?.customSegmentsMeta?.AccountSegments;
export const selectCurrentDashboard = (state: RootState) => state.customDashboard.currentDashboard;
export const selectIsEditing = (state: RootState) => state.customDashboard.dashboardWizard.isEditing;
export const selectSegmentsId = (state: RootState) =>
    state.customDashboard.dashboardWizard.widget.filters.selectedSegmentsId;
const selectDashboardSegmentsGroups = (state: RootState) =>
    state.segmentsModule?.dashboardSegmentsMeta?.SegmentGroups;

export const selectdUserSegmentsGroups = (state: RootState) =>
    state?.segmentsModule?.dashboardSegmentsMeta?.SegmentGroups;
const selectSegmentsGroups = (state: RootState) => state.segmentsModule?.customSegmentsMeta?.SegmentGroups;
